/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import Loading from "../../common/Loading";
import TableActions from "../../common/TableActions";

const ProjectNotificationsList = ({
  data,
  loading,
  onClickView,
  onClickDelete
}) => {
  if (loading) {
    return (
      <div className="loading">
        <Loading />
      </div>
    );
  }

  const props = {
    getTdProps: (state, rowInfo, column) => {
      if (!column.expander) {
        return {
          onClick: () => {
            if (column.id !== "_id" && rowInfo?.original?._id) {
              onClickView(rowInfo.original._id);
            }
          }
        };
      }
      return {};
    }
  };

  const columns = [
    {
      Header: "Type",
      accessor: "type.label",
      id: "type.label"
    },
    {
      Header: "Description",
      accessor: "num_days",
      id: "num_days",
      Cell: ({ value }) => <span>{value ? `${value} days before` : ""}</span>
    },
    {
      Header: "",
      accessor: "_id",
      maxWidth: 80,
      filterable: false,
      Cell: (row) => (
        <TableActions
          onClickView={() => onClickView(row.value)}
          onClickDelete={() => onClickDelete(row.value)}
        />
      )
    }
  ];

  return data && data.length ? (
    <div className="content-wrapper">
      <ReactTable
        {...props}
        className="-highlight"
        columns={columns}
        data={data}
        defaultSorted={[
          {
            id: "type.label",
            desc: false
          }
        ]}
        pageSize={data.length}
        showPagination={false}
      />
    </div>
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};
ProjectNotificationsList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  isMobile: PropTypes.bool,
  onClickView: PropTypes.func,
  onClickDelete: PropTypes.func
};

export default ProjectNotificationsList;
